import { render, staticRenderFns } from "./CarEdit.vue?vue&type=template&id=071d2e5e&scoped=true&"
import script from "./CarEdit.vue?vue&type=script&lang=ts&"
export * from "./CarEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d2e5e",
  null
  
)

export default component.exports